import PropTypes from "prop-types";
import clsx from "clsx";
import Swiper, { SwiperSlide } from "../../components/swiper";
import BrandLogoOneSingle from "../../components/brand-logo/BrandLogoOneSingle";
import React, { useEffect } from "react";
import useTranslationHook from "../../hooks/useTranslationHook";
import { HomepageBrand } from "../../shared/commonUtils";
import NcdHaier from "../../assets/images/ncd-brand-logo/ncd-haier.png";
import NcdGE from "../../assets/images/ncd-brand-logo/ncd-ge.png";
const settings = {
  // loop: true,
  autoplay: true,
  grabCursor: true,
  breakpoints: {
    320: {
      slidesPerView: 2,
    },
    640: {
      slidesPerView: 3,
    },
    1024: {
      slidesPerView: 5,
    },
    768: {
      slidesPerView: 4,
    },
  },
};
interface IBrandLogoSliderOne {
  spaceBottomClass: any;
  spaceTopClass: any;
  homePageBrandLogo: HomepageBrand[];
}
const BrandLogoSliderNCD: React.FC<IBrandLogoSliderOne> = (
  props: IBrandLogoSliderOne
) => {
  // const {loading,getHomePageBrands,homePageBrandLogo} = useGetHomePage();
  const { t } = useTranslationHook();
  const { spaceBottomClass, spaceTopClass, homePageBrandLogo } = props;

  const imagesData = [{ image: NcdHaier }, { image: NcdGE }];
  useEffect(() => {
    console.log(homePageBrandLogo);
    // getHomePageBrands('1','1','home','brands')
  }, [homePageBrandLogo]);
  return (
    <div
      style={{ background: "var(--button-color)" }}
      className={clsx("brand-logo-area", spaceBottomClass, spaceTopClass)}
    >
      <div className="container">
        <div className=" shop-by-brand-title text-center">
          {t("trusted_brands")}
        </div>
        <div className="brand-logo-active">
          <Swiper options={settings}>
            {imagesData.map((single, key) => (
              <SwiperSlide
                style={{ width: "100%", height: 80 }}
                key={key}
                className="swiper-slider-brand"
              >
                <BrandLogoOneSingle
                  data={single}
                  spaceBottomClass="mb-30"
                  removeBorders
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

BrandLogoSliderNCD.propTypes = {
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default BrandLogoSliderNCD;
